export enum ClaraEvent {
  ON_ASK_NEW_QUESTION_CLICKED = 'ClaraEvent:ON_ASK_NEW_QUESTION_CLICKED',
  ON_QUESTION_CLICKED = 'ClaraEvent:ON_QUESTION_CLICKED',
  ON_SEARCH_TERM_CHANGED = 'ClaraEvent:ON_SEARCH_TERM_CHANGED',
  ON_SHOW_CLARA_INTRO = 'ClaraEvent:ON_SHOW_CLARA_INTRO',
  CLARA_INPUT_FOCUSED = 'ClaraEvent:CLARA_INPUT_FOCUSED',
  ON_PENDING_FEEDBACK_CONVERSATION_CLICKED = 'ClaraEvent:ON_PENDING_FEEDBACK_CONVERSATION_CLICKED'
}
